import styled from '@emotion/styled';
// eslint-disable-next-line no-restricted-imports
import { Tooltip as MuiTooltip, TooltipProps } from '@mui/material';

const StyledTooltipContainer = styled.div`
  display: flex;
`;

export const Tooltip = ({ children, title, ...props }: TooltipProps) => {
  return (
    <MuiTooltip title={title || children} {...props} arrow>
      {/* div is necessary here to avoid warning about passed ref */}
      <StyledTooltipContainer>{children}</StyledTooltipContainer>
    </MuiTooltip>
  );
};
